<div class="assessment-container">
  @if (patient().isPediatric()) {
  <h2>Humpty Dumpty Fall Scale</h2>
  <assessment-row title="Age" [historyMode]="true">
    <p>{{ data().HDage }}</p>
  </assessment-row>
  <assessment-row title="Gender" [historyMode]="true">
    <p>{{ data().HDgender }}</p>
  </assessment-row>
  <assessment-row title="Diagnosis" [historyMode]="true">
    <p>{{ data().HDdiagnosis }}</p>
  </assessment-row>
  <assessment-row title="Cognitive Impairment" [historyMode]="true">
    <p>{{ data().HDcognitiveImpairment }}</p>
  </assessment-row>
  <assessment-row title="Environmental Factors" [historyMode]="true">
    <p>{{ data().HDenvironmentalFactors }}</p>
  </assessment-row>
  <assessment-row title="Response to Surgery" [historyMode]="true">
    <p>{{ data().HDresponseToSurgery }}</p>
  </assessment-row>
  <assessment-row title="Medication Usage" [historyMode]="true">
    <p>{{ data().HDmedicationUsage }}</p>
  </assessment-row>
  <assessment-row title="Total Humpty Dumpty Score" [historyMode]="true">
    <p>{{ data().HDtotalScore }}</p>
  </assessment-row>
  <assessment-row title="Fall Risk" [historyMode]="true">
    <p>{{ HDfallRisk }}</p>
  </assessment-row>
  } @else {
  <h2>Fall Risk Assessment</h2>
  <assessment-row title="Age" [historyMode]="true">
    <p>{{ data().fallRiskAge }}</p>
  </assessment-row>
  <assessment-row title="Fall History" [historyMode]="true">
    <p>{{ hasFallHistory }}</p>
  </assessment-row>
  <assessment-row title="Elimination, Bowel and Urine" [historyMode]="true">
    <p>{{ data().fallRiskEbu }}</p>
  </assessment-row>
  <assessment-row title="Medications"
    description="Includes PCA/opiates, anticonvulsants, anti-hypertensives, diuretics, hypnotics, laxatives, sedatives, and psychotropics"
    [historyMode]="true">
    <p>{{ data().fallRiskMedications }}</p>
  </assessment-row>
  <assessment-row title="Patient Care Equipment"
    description="Any equipment that tethers patient (e.g. IV infusion, chest tube, indwelling catheter, SCDs, etc.)"
    [historyMode]="true">
    <p>{{ data().fallRiskPce }}</p>
  </assessment-row>
  <assessment-row title="Mobility" [historyMode]="true">
    <emr-list [list]="data().fallRiskMobility" emptyText="N/A"></emr-list>
  </assessment-row>
  <assessment-row title="Cognition" [historyMode]="true">
    <emr-list [list]="data().fallRiskCognition" emptyText="N/A"></emr-list>
  </assessment-row>
  <assessment-row title="Total Fall Risk Score" description="Sum of all points per category" [historyMode]="true">
    <p>{{ data().fallScore }}</p>
  </assessment-row>
  <assessment-row title="Fall Risk" [historyMode]="true">
    <p>{{ fallRiskCategory }}</p>
  </assessment-row>
  }

  <assessment-row title="Mobility" [historyMode]="true">
    <p>{{ data().mobilityAndTransfers }}</p>
  </assessment-row>
  <assessment-row title="Assistive Devices" [historyMode]="true">
    <emr-list [list]="data().assistiveDevices" emptyText="None"></emr-list>
  </assessment-row>

  <assessment-row title="Limited Range of Motion" [historyMode]="true">
    <p>{{ data().limitedRangeOfMotion }}</p>
  </assessment-row>

  <assessment-row title="Deformities Present" [historyMode]="true">
    <p>{{ data().deformitiesPresent }}</p>
  </assessment-row>

  <assessment-row title="Other Findings" [historyMode]="true">
    <p>{{ data().otherFindings || 'N/A' }}</p>
  </assessment-row>
</div>